import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import ProductsRow from '../ProductsRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class ProductsTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        ecommerceCategory: PropTypes.shape({
          products: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    return (
      <>
        <FilterContainer>
          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='ecommerce' section='products'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_ecommerce_product_name' size='8' />
            <Translate content='crawler_source_page_url' size='4' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={ProductsRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(ProductsTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment ProductsTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              products(offset: $offset, limit: $limit, sourceUrl: $sourceUrl) {
                count
                edges {
                  node {
                    ...ProductsRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query ProductsTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $sourceUrl: TextFilters) {,
        project (host: $host) {
          ...ProductsTable_project @arguments(
            offset: $offset,
            limit: $limit,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
